import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: 'GT Eesti';
    src: url('/fonts/gt-eesti-thin.otf') format('opentype');
    font-weight: 100;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'GT Eesti';
    src: url('/fonts/gt-eesti-light.otf') format('opentype');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'GT Eesti';
    src: url('/fonts/gt-eesti-regular.otf') format('opentype');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'GT Eesti';
    src: url('/fonts/gt-eesti-medium.otf') format('opentype');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'GT Eesti';
    src: url('/fonts/gt-eesti-bold.otf') format('opentype');
    font-weight: 700;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'GT Eesti';
    src: url('/fonts/gt-eesti-ultrabold.otf') format('opentype');
    font-weight: 800;
    font-style: normal;
    font-display: swap;
  }

  * { margin: 0; padding: 0; box-sizing: border-box; }

  body {
    font-family: 'GT Eesti', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    background: #0a0a0f;
    color: #fff;
    overflow-x: hidden;
    -webkit-font-smoothing: antialiased;
    font-size: 14px;
    line-height: 1.5;
    min-height: 100vh;
  }

  #root {
    min-height: 100vh;
    background: #0a0a0f;
  }

  ::-webkit-scrollbar { width: 0; height: 0; }

  :root {
    --bg: #0a0a0f;
    --card: #14141f;
    --card-hover: #1a1a2e;
    --accent: #006FFF;
    --accent2: #0055cc;
    --text: #ffffff;
    --text2: #8e8e9a;
    --text3: #55556a;
    --border: rgba(255,255,255,0.06);
    --green: #00c853;
    --red: #ff3b30;
    --orange: #ff9500;
    --yellow: #ffd60a;
    --radius: 14px;
    --radius-sm: 10px;
    --radius-xs: 6px;
  }

  a { color: inherit; text-decoration: none; }

  @keyframes fadeUp {
    from { opacity: 0; transform: translateY(16px); }
    to { opacity: 1; transform: translateY(0); }
  }

  @keyframes shimmer {
    0% { background-position: -400px 0; }
    100% { background-position: 400px 0; }
  }

  .fade-up { animation: fadeUp 0.4s ease both; }
`;

export default GlobalStyles;
